import { Box, Button, Container, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link } from "react-router-dom";
import {
  DASHBOARD_SCREEN_ROUTE,
} from "../routes";
const GetTechnicalHelp = () => {
  return (
    <>
      <Box
        component="main"
        sx={{
          alignItems: "center",
          display: "flex",
          flexGrow: 1,
          minHeight: "100vh",
        }}
      >
        <Container maxWidth="md">
          <Box
            sx={{
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography align="center" color="textPrimary" variant="h3">
              For any Query Contact E-Mareez Care
            </Typography>
            <Box
              sx={{ cursor: "pointer", fontSize: "32px", fontWeight: "bold", mt:2}}
            >
              03095558054
            </Box>
            <Box sx={{ cursor: "pointer", fontSize: "26px", mt:-3 }}>
              <a href="mailto:info@e-mareez.com">
                <p>info@e-mareez.com</p>
              </a>
            </Box>
           
            <Box sx={{ textAlign: "center" }}>
              {/* <img
                alt="Under development"
                src="/images/undraw_page_not_found.svg"
                style={{
                  marginTop: 50,
                  display: "inline-block",
                  maxWidth: "100%",
                  width: 560,
                }}
              /> */}
            </Box>
            <Link
              to={DASHBOARD_SCREEN_ROUTE}
              style={{ textDecoration: "none" }}
            >
              <Button
                component="a"
                startIcon={<ArrowBackIcon fontSize="small" />}
                sx={{ mt: 3 }}
                variant="contained"
              >
                Go back to dashboard
              </Button>
            </Link>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default GetTechnicalHelp;
